import { TableRow } from '../../../../ps-aspect-design';

export enum MatchStrategy {
  CURRENT = 'current',
  FILE = 'file'
}

export enum PropagateMatchOption {
  ALL = 'all',
  SELECT_JOBS = 'select'
}

export enum PromoteMode {
  OVERWRITE_ALL_AND_PRESERVE = 'overwrite_all',
  OVERWRITE_EXISTING = 'overwrite_existing',
  CREATE_NEW = 'create_new'
}

export enum RunStatus {
  RUNNING = 'running',
  SUCCESS = 'success',
  FAILED = 'failed'
}

export interface PricingVersion extends TableRow  {
  id: number;
  name: string;
  organizationId: number;
  jobCount: number;
  isCurrent: boolean;
  description: string;
  matchStrategy: MatchStrategy;
  created: Date | string;
  createdBy: string;
  lastModified: Date | string;
  lastModifiedBy: string;
  shouldPropagate: boolean;
  propagateMatchOption: PropagateMatchOption;
  propagateMatchJobSelection: string[];
  requiresRun: boolean;
  metadata?: PricingVersionMetaData;
  runStatus: null | RunStatus;
  hasNotified: boolean;
}

export interface PricingVersionMetaData {
  filename: string;
  uploadDate: Date;
  userId: number;
  user: string;
}

export interface UploadError {
    column_name: string
    error_id: number
    error_text: string
    error_time: string
    row_numbers: number[]
    target_table_name: string
    temp_table_name: string
    user_id: number
}
